import layout from 'layouts/default'
import pagination from 'components/pagination'
import { hasPermits } from 'directives'

const components = {
  layout,
  pagination
}

const directives = {
  hasPermits
}

const methods = {
  loadPage (page, searchKey = null) {
    this.$route.query.page = page
    this.loading = true
    const queryParams = {
      page,
      per_page: 20
    }
    if (searchKey) {
      queryParams.search = searchKey
    }
    return this.$store.dispatch('dashboards.getAirports', queryParams).then(() => {
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  search (searchKey) {
    this.searchKey = searchKey
    this.loadPage(1, searchKey)
  }
}

const computed = {
  airports () {
    const data = _.cloneDeep(this.$store.state.dashboards.airports)
    if (data && Array.isArray(data.data)) {
      return data
    }
    if (data && data.airports && Array.isArray(data.airports.data)) {
      return data.airports
    }
    const list = Array.isArray(data)
      ? data
      : (data && Array.isArray(data.airports) ? data.airports : [])
    return {
      data: list,
      last_page: 1
    }
  },
  airportsList () {
    return this.airports.data || []
  }
}

export default {
  name: 'all-airports',
  components,
  methods,
  computed,
  directives,
  data () {
    return {
      loading: true,
      searchKey: null
    }
  },
  created () {
    this.loadPage(this.$route.query.page || 1)
  }
}
